export default "__VITE_ASSET__bd360b77__"